/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_TitleInputs */

const en_fw_faq_title = /** @type {(inputs: Fw_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding FAQ`)
};

const zh_fw_faq_title = /** @type {(inputs: Fw_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁常见问题`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding FAQ" |
*
* @param {Fw_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_title = /** @type {((inputs?: Fw_Faq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_title(inputs)
	return zh_fw_faq_title(inputs)
});
export { fw_faq_title as "fw.faq.title" }